import React from "react";
import PropTypes from "prop-types";
import GenericNavList from "./GenericNavList";
import style from "../../../scss/components/MainNavigation";
// import logo from '../../../img/logo.jpeg';
import logo from "../../../img/logo.webp";

import enLangLogo from "../../../img/globe.svg";
import cnLangLogo from "../../../img/globe.svg";
import geLangLogo from "../../../img/globe.svg";
import esLangLogo from "../../../img/globe.svg";
import ImageBlock from "../ImageBlock";
import searchIcon from "../../../img/search.svg";
import closeIcon from "../../../img/close.svg";

export default class DesktopNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchOpen: false,
      searchFocus: false,
      menuOpen: false,
      langMenuOpen: false,
      searchClass: "",
      langBlog: false,
    };
    this.searchInputRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSearchSubmenu = this.handleSearchSubmenu.bind(this);
    this.closeSearchSubmenu = this.closeSearchSubmenu.bind(this);
    this.toggleClose = this.toggleClose.bind(this);
  }

  static propTypes = {
    mainMenuItems: PropTypes.array,
    contact_page_en_url: PropTypes.string,
    contact_page_uk_url: PropTypes.string,
    contact_page_es_url: PropTypes.string,
    search_page_en_url: PropTypes.string,
    search_page_uk_url: PropTypes.string,
    search_page_es_url: PropTypes.string,
  };

  static defaultProps = {
    mainMenuItems: [],
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    let bstr = window.location.href;
    if (bstr.includes("/blog")) {
      this.setState({ langBlog: true }, () => {});
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside(event) {
    if (this.node && !this.node.contains(event.target)) {
      this.showSearch(false);
    }
  }
  toggleMenu() {
    let isMenuOpen = this.state.menuOpen;
    this.setState({ menuOpen: !isMenuOpen });
  }
  showSearch(flag) {
    var self = this;
    this.setState({ searchOpen: flag }, () => {
      window.setTimeout(function () {
        self.searchInputRef.current.focus();
      }, 100);
    });
  }
  toggleSearch() {
    var self = this;
    let isSearchOpen = self.state.searchOpen;
    let isMobile = window.innerWidth <= 1049;

    if (isMobile) {
      if (isSearchOpen) {
        this.setState({ searchOpen: false, searchFocus: false });
      } else {
        this.performSearch();
      }
    } else {
      this.setState({ searchOpen: !isSearchOpen }, () => {
        if (this.state.searchOpen) {
          window.setTimeout(function () {
            self.searchInputRef.current.focus();
          }, 100);
        }
      });
    }
  }

  toggleClose() {
    var self = this;
    let isSearchOpen = self.state.searchOpen;
    this.setState({ searchOpen: !isSearchOpen, searchFocus: false }, () => {});
  }
  handleSearchSubmenu() {
    var self = this;
    this.setState({ searchFocus: true }, () => {});
  }

  closeSearchSubmenu() {
    var self = this;
    this.setState({ searchFocus: false }, () => {});
  }

  performSearch() {
    let str = window.location.href;
    let search_page_url = str.includes("/es/")
      ? this.props.search_page_es_url
      : str.includes("/en-uk/")
      ? this.props.search_page_uk_url
      : this.props.search_page_en_url;
    if (this.state.query)
      window.location = search_page_url + "?query=" + this.state.query;
  }
  handleSearchClick = () => {
    if (this.state.menuOpen) this.performSearch();
    else this.showSearch(true);
  };
  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.performSearch();
    }
  };
  getImageProp = () => {
    let img = {};
    img.url = logo;
    return img;
  };
  getEnLangImageProp = () => {
    let img = {};
    img.url = enLangLogo;
    return img;
  };
  getCnLangImageProp = () => {
    let img = {};
    img.url = cnLangLogo;
    return img;
  };
  getGerLangImageProp = () => {
    let img = {};
    img.url = geLangLogo;
    return img;
  };
  getSpnLangImageProp = () => {
    let img = {};
    img.url = esLangLogo;
    return img;
  };

  togglelangMenu_China() {
      location.href = "https://www.hunterlabcolor.cn/";
  }
  
  togglelangMenu_Germany() {
    location.href = "https://www.hunterlab.de";
  }
  togglelangMenu(lang) {
    let str = window.location.href;
    if (str.includes("/es/")) {
      if (lang == "English") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/es/", "/en/");
      } else if (lang == "UK English") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/es/", "/en-uk/");
      }
    }
    if (str.includes("/en/")) {
      if (lang == "Español") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/en/", "/es/");
      } else if (lang == "UK English") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/en/", "/en-uk/");
      }
    }
    if (str.includes("/en-uk/")) {
      if (lang == "Español") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/en-uk/", "/es/");
      } else if (lang == "English") {
        location.href =
          window.location.origin +
          window.location.pathname.replace("/en-uk/", "/en/");
      }
    }
  }

  toggleMenuList() {
    let isLangMenuOpen = this.state.langMenuOpen;
    this.setState({ langMenuOpen: !isLangMenuOpen });
  }

  render() {
    let str = window.location.href;
    let contact_page_url,
      home_url,
      home_flag,
      other_flag,
      country_name,
      home_Name1,
      home_Name2,
      new_path,
      contact_name,
      search_text,
      url1,
      url2,
      url3,
      url4,
      url5;
    if (str.includes("/es/")) {
      contact_page_url = this.props.contact_page_es_url;
      home_url = window.location.origin + "/es/";
      home_flag = this.getSpnLangImageProp();
      other_flag = this.getEnLangImageProp();
      country_name = "USA";
      home_Name1 = "English";
      home_Name2 = "UK English";
      contact_name = "Obtenga un presupuesto";
      search_text = "Búsqueda HunterLab.com";
      url1 =
        window.location.origin +
        "/es/products/benchtop-spectrophotometers/agera/";
      url2 =
        window.location.origin +
        "/es/products/benchtop-spectrophotometers/colorflex-ez/";
      url3 =
        window.location.origin +
        "/es/products/benchtop-spectrophotometers/aeros/";
      url4 =
        window.location.origin +
        "/es/products/benchtop-spectrophotometers/vista/";
      url5 =
        window.location.origin +
        "/es/products/portable-spectrophotometers/miniscan-ez-4500/";
    }
    if (str.includes("/en-uk/")) {
      contact_page_url = this.props.contact_page_uk_url;
      home_url = window.location.origin + "/en-uk/";
      home_flag = this.getEnLangImageProp();
      other_flag = this.getSpnLangImageProp();
      home_Name1 = "English";
      home_Name2 = "Español";
      contact_name = "Get Quote";
      search_text = "Search HunterLab.com";
      url1 =
        window.location.origin +
        "/en-uk/products/benchtop-spectrophotometers/agera/";
      url2 =
        window.location.origin +
        "/en-uk/products/benchtop-spectrophotometers/colorflex-ez/";
      url3 =
        window.location.origin +
        "/en-uk/products/benchtop-spectrophotometers/aeros/";
      url4 =
        window.location.origin +
        "/en-uk/products/benchtop-spectrophotometers/vista/";
      url5 =
        window.location.origin +
        "/en-uk/products/portable-spectrophotometers/miniscan-ez-4500/";
    }
    if (str.includes("/en/")) {
      contact_page_url = this.props.contact_page_en_url;
      home_url = window.location.origin + "/en/";
      home_flag = this.getEnLangImageProp();
      other_flag = this.getSpnLangImageProp();
      country_name = "Latin America";
      home_Name1 = "Español";
      home_Name2 = "UK English";
      contact_name = "Get Quote";
      search_text = "Search HunterLab.com";
      url1 =
        window.location.origin +
        "/en/products/benchtop-spectrophotometers/agera/";
      url2 =
        window.location.origin +
        "/en/products/benchtop-spectrophotometers/colorflex-ez/";
      url3 =
        window.location.origin +
        "/en/products/benchtop-spectrophotometers/aeros/";
      url4 =
        window.location.origin +
        "/en/products/benchtop-spectrophotometers/vista/";
      url5 =
        window.location.origin +
        "/en/products/portable-spectrophotometers/miniscan-ez-4500/";
    }

    if (str.includes("/blog/")) {
      contact_name = "Get Quote";
      home_url = window.location.origin + "/en/";
      contact_page_url = this.props.contact_page_en_url;
      search_text = "Search HunterLab.com";
      url1 =
        window.location.origin +
        "/en/products/benchtop-spectrophotometers/agera/";
      url2 =
        window.location.origin +
        "/en/products/benchtop-spectrophotometers/colorflex-ez/";
      url3 =
        window.location.origin +
        "/en/products/benchtop-spectrophotometers/aeros/";
      url4 =
        window.location.origin +
        "/en/products/benchtop-spectrophotometers/vista/";
      url5 =
        window.location.origin +
        "/en/products/portable-spectrophotometers/miniscan-ez-4500/";
    }

    return (
      <section className="navbar">
        <div className="navbar-inner">
          <div className="navbar-left">
            <a className="navbar-logo" href={home_url}>
              <ImageBlock
                style={{ width: "132px !important" }}
                title="HunterLab Logo"
                image={this.getImageProp()}
                addWrapper={false}
              ></ImageBlock>
            </a>
            <a
              href={contact_page_url}
              className="mobilecontact btn btn-outline-contact"
            >
              {contact_name}
            </a>

            {!this.state.langBlog && (
              <button
                className={
                  "sm-menu-lang-view" + (this.state.menuOpen ? " close" : " ")
                }
                onClick={() => this.toggleMenuList()}
              >
                <ImageBlock image={home_flag} addWrapper={false}></ImageBlock>
                <div
                  className={
                    "sm-menu-lang-list" +
                    (this.state.langMenuOpen && !this.state.menuOpen
                      ? " open"
                      : " close")
                  }
                >
                  <ul>
                    <li class="menu-li-lang">
                      <a href="#" onClick={() => this.togglelangMenu_China()}>
                        <ImageBlock
                          image={this.getCnLangImageProp()}
                          addWrapper={false}
                        ></ImageBlock>
                        <span className="lang-txt-sm">简体中文</span>
                      </a>
                    </li>
                    <li class="menu-li-lang">
                      <a href="#" onClick={() => this.togglelangMenu_Germany()}>
                        <ImageBlock
                          image={this.getGerLangImageProp()}
                          addWrapper={false}
                        ></ImageBlock>
                        <span className="lang-txt-sm">Deutsch</span>
                      </a>
                    </li>
                    <li class="menu-li-lang">
                      <a
                        href="#"
                        onClick={() => this.togglelangMenu(home_Name1)}
                      >
                        <ImageBlock
                          image={other_flag}
                          addWrapper={false}
                        ></ImageBlock>
                        <span className="lang-txt">{home_Name1}</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="#"
                        onClick={() => this.togglelangMenu(home_Name2)}
                      >
                        <ImageBlock
                          image={other_flag}
                          addWrapper={false}
                        ></ImageBlock>
                        <span className="lang-txt">{home_Name2}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </button>
            )}

            <button
              className={"toggle-btn" + (this.state.menuOpen ? " open" : "")}
              onClick={() => this.toggleMenu()}
            ></button>
          </div>
          <nav
            className={
              "navbar-right" +
              (this.state.searchOpen ? " active" : "") +
              (this.state.menuOpen ? " open" : "")
            }
          >
            <GenericNavList
              prefix="navbar-nav"
              items={this.props.mainMenuItems}
              showDesc={true}
            ></GenericNavList>
            <div className="navbar-right-right">
              <div className="nav-contact-menu">
                <li className="nav-btn">
                  <a
                    href={contact_page_url}
                    className="btn btn-outline-contact desktopcontact get-quote-btn"
                  >
                    {contact_name}
                  </a>
                </li>
              </div>
              {!this.state.searchOpen && !this.state.langBlog && (
                <li className=" has-menu menu-lang-selector">
                  <button>
                    <img
                      style={{ maxWidth: "none" }}
                      src={enLangLogo}
                      class="img-object"
                    />
                    <div className="sub-nav mega-menu">
                      <div className="mega-menu-right">
                        <ul className="menu">
                          <li class="menu-li-lang">
                            <a
                              href="#"
                              onClick={() => this.togglelangMenu_China()}
                            >
                              <ImageBlock
                                image={this.getCnLangImageProp()}
                                addWrapper={false}
                              ></ImageBlock>
                              <span className="lang-txt">简体中文</span>
                            </a>
                          </li>
                          <li class="menu-li-lang">
                            <a
                              href="#"
                              onClick={() => this.togglelangMenu_Germany()}
                            >
                              <ImageBlock
                                image={this.getGerLangImageProp()}
                                addWrapper={false}
                              ></ImageBlock>
                              <span className="lang-txt">Deutsch </span>
                            </a>
                          </li>
                          <li class="menu-li-lang">
                            <a
                              href="#"
                              onClick={() => this.togglelangMenu(home_Name1)}
                            >
                              <ImageBlock
                                image={other_flag}
                                addWrapper={false}
                              ></ImageBlock>
                              <span className="lang-txt">{home_Name1}</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="#"
                              onClick={() => this.togglelangMenu(home_Name2)}
                            >
                              <ImageBlock
                                image={other_flag}
                                addWrapper={false}
                              ></ImageBlock>
                              <span className="lang-txt">{home_Name2}</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </button>
                </li>
              )}
              <form
                className="nav-search-form"
                ref={(node) => (this.node = node)}
              >
                <div className="form-group has-icon">
                  <div className="icon-addon">
                    <input
                      ref={this.searchInputRef}
                      type="text"
                      className="form-control"
                      placeholder={search_text}
                      onChange={(event) => {
                        this.setState({ query: event.target.value });
                      }}
                      onKeyPress={this.handleKeyPress}
                      onFocus={this.handleSearchSubmenu}
                    />
                    {this.state.searchOpen && window.innerWidth > 1049 && (
                      <img role="img" src={searchIcon} />
                    )}
                  </div>
                  {!this.state.searchOpen && window.innerWidth > 1049 && (
                    <a
                      onClick={() => this.toggleSearch()}
                      className="form-icon icon-search"
                    ></a>
                  )}
                  {!this.state.searchOpen && window.innerWidth < 1049 && (
                    <a
                      onClick={() => this.toggleSearch()}
                      className="form-icon icon-search"
                    ></a>
                  )}
                  {this.state.searchOpen && window.innerWidth > 1049 && (
                    <img
                      className="form-icon"
                      style={{ width: "19px", top: "53%", right: "-8%" }}
                      onClick={() => this.toggleClose()}
                      role="img"
                      src={closeIcon}
                    />
                  )}
                  {this.state.searchFocus &&
                    this.state.searchOpen &&
                    window.innerWidth > 1049 && (
                      <div className="sub-nav-search">
                        <div className="search-dropmenu">
                          <span className="search-top">QUICK LINKS</span>
                          <div className="search-menu">
                            <a href={url1}>Agera</a>
                            <a href={url2}>ColorFlex EZ</a>
                            <a href={url3}>Aeros</a>
                            <a href={url4}>Vista</a>
                            <a href={url5}>MiniScan EZ 4500</a>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              </form>
            </div>
          </nav>
        </div>
      </section>
    );
  }
}
